import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { UserState } from 'src/app/state/user-state';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  selectUnreadNotificationCount,
  selectUserBalanceInMBC
} from 'src/app/state/reducer/user.reducer';
import { ICONS } from 'src/app/core/constants/icons';
import { ROUTES } from 'src/app/core/constants/routes';
import { HeaderService } from 'src/app/core/services/header.service';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { DialogService } from 'src/app/core/services/dialog.service';

@Component({
  selector: 'app-status-bar',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  protected $mbcBalance: Observable<number | undefined> = this.store.pipe(
    select(selectUserBalanceInMBC)
  );
  protected $unreadCount = this.store.pipe(select(selectUnreadNotificationCount));

  protected ARROW_LEFT_WHITE = ICONS.ARROW_LEFT_WHITE;
  protected INFO_WHITE = ICONS.INFO_WHITE;
  protected LOGO = ICONS.LOGO;
  protected MBC_FRONT_SIDE = ICONS.MBC_FRONT_SIDE;
  protected NOTIFICATION_BELL = ICONS.NOTIFICATION_BELL;

  private $destroy = new Subject<void>();

  protected showNavBackButton = false;

  constructor(
    private store: Store<UserState>,
    protected headerService: HeaderService,
    private location: Location,
    private router: Router,
    private dialogService: DialogService
  ) {
    this.headerService.setCurrentNavBar();
    this.setNavButtonVisibility();
  }

  ngOnInit(): void {
    this.router.events.pipe(takeUntil(this.$destroy)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.headerService.setCurrentNavBar();
        this.setNavButtonVisibility();
      }
    });
  }

  openInfoModal() {
    this.dialogService.openConfirmation('', this.headerService.currentNavBar!.infoMessage);
  }

  navigateBack() {
    this.location.back();
  }

  navigateToHome() {
    this.router.navigate([ROUTES.HOME]);
  }

  navigateToNotifications() {
    this.router.navigate([ROUTES.NOTIFICATIONS]);
  }

  setNavButtonVisibility() {
    this.showNavBackButton = !this.router.url.includes(ROUTES.HOME);
  }

  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }
}
